// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"ffd3a90e","787":"f57f07ab"}[chunkId] + ".chunk.js";
};